import store from "@/js/store";

export function getReasonsToSkip(skipLeadConditions) {
	return [
		"CAMPAIGN_DUPLICATE",
		...skipLeadConditions
	];
}

export function hasSelectedLeadsFilters(skipLeadConditions = []) {
	return skipLeadConditions.length > 1 || (skipLeadConditions.length === 1 && skipLeadConditions[0] !== "CAMPAIGN_DUPLICATE");
}

export function hasSlowLeadsFilters(skipLeadConditions = []) {
	const slowLeadConditions = store.getters.advancedReasons.map(condition => condition.value);

	return skipLeadConditions.some(condition => slowLeadConditions.includes(condition));
}

export function hasAiPoweredLeadsFilters(skipLeadConditions = []) {
	return false;
}

export function getFilterState(skipLeadConditions) {
	const isSelected = hasSelectedLeadsFilters(skipLeadConditions);
	const isSlow = hasSlowLeadsFilters(skipLeadConditions);
	const isAI = hasAiPoweredLeadsFilters(skipLeadConditions);

	switch ((isSelected << 2) | (isSlow << 1) | isAI) {
	case 0 : return "FILTER_EMPTY";
	case 7 : case 5 : case 3 : case 1 : return "FILTER_AI_POWERED";
	case 6 : case 2 : return "FILTER_LONG";
	case 4 : return "FILTER_SHORT";
	default : return "";
	}
}
